// Create clickable links for student details
const createStudentLink = (text, memberId) => {
  if (!text || !memberId) return text || "";
  const url = `/admin/student/details/${memberId}?action=view&key=tab1`;
  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      style={{ textDecoration: "none", color: "#007bff" }}
      onClick={e => e.stopPropagation()}
    >
      {text}
    </a>
  );
};

export default createStudentLink;